import script from "./DiagnosticReport.vue?vue&type=script&lang=ts&setup=true"
export * from "./DiagnosticReport.vue?vue&type=script&lang=ts&setup=true"

import "./DiagnosticReport.vue?vue&type=style&index=0&id=a08896d8&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a08896d8"]])

export default __exports__